// 首页静态展示内容数据（虚构示例内容，不指向任何真实公众人物）

export type GossipCategory = "明星" | "网红" | "主播";

export interface HotCard {
  id: number;
  category: GossipCategory;
  kicker: string;
  title: string;
  summary: string;
  tags: string[];
  image: string;
  heat: number;
  comments: number;
  time: string;
}

export interface RankItem {
  id: number;
  category: GossipCategory;
  name: string;
  title: string;
  note: string;
  trend: "up" | "down" | "flat";
  heat: number;
}

export interface PersonArch {
  id: number;
  name: string;
  category: GossipCategory;
  glyph: string;
  tone: string;
  tagline: string;
  since: string;
  entries: number;
  peek: string;
}

export interface TimelineStep {
  time: string;
  title: string;
  desc: string;
  image?: string;
  hot?: boolean;
}

export interface GalleryItem {
  image: string;
  caption: string;
  tag: string;
}

export interface CommentReply {
  user: string;
  text: string;
  likes: number;
}

export interface CommentItem {
  id: number;
  user: string;
  role: string;
  text: string;
  likes: number;
  replies: CommentReply[];
}

export interface PollOption {
  label: string;
  votes: number;
}

export const hotTopics: string[] = [
  "顶流偷税被查",
  "塌房连夜发声明",
  "带货翻车后续",
  "直播失言道歉",
  "金主连夜解约",
  "综艺黑幕录音",
];

export const hotCards: HotCard[] = [
  {
    id: 1,
    category: "明星",
    kicker: "重磅实锤",
    title: "一线男星被曝偷税补缴上亿，工作室深夜紧急删帖灭口",
    summary:
      "多家票务与商务线索指向该艺人近两年高额演出收入异常走账，税务稽查已介入，多个待宣品牌方连夜评估解约条款。",
    tags: ["税务", "补缴", "解约风波"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20dark%20backstage%20corridor%20with%20spotlight%20beams%20and%20hazy%20smoke%2C%20vintage%20press%20conference%20atmosphere%2C%20warm%20and%20cool%20contrast%20lighting%2C%20no%20visible%20person%2C%20film%20grain%2C%20moody%20red%20accent%20glow%2C%20editorial%20documentary%20style&width=1200&height=760&seq=hot-01&orientation=landscape",
    heat: 9.8,
    comments: 3214,
    time: "12分钟前",
  },
  {
    id: 2,
    category: "主播",
    kicker: "直播翻车",
    title: "带货主播当众算错优惠被弹幕围攻，怒摔样品离场",
    summary:
      "一场号称全网最低价的大促里，主播反复改口价格被打脸，连麦商家当场拆台，围观人数反而冲到新高。",
    tags: ["带货", "打脸", "大促"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20bright%20modern%20live%20streaming%20studio%20set%20with%20ring%20lights%20and%20product%20boxes%2C%20empty%20chair%20center%20stage%2C%20harsh%20key%20light%20and%20soft%20fill%2C%20warm%20toned%2C%20no%20visible%20person%2C%20commercial%20documentary%20feel%2C%20clean%20high%20detail&width=1000&height=680&seq=hot-02&orientation=landscape",
    heat: 8.6,
    comments: 1856,
    time: "26分钟前",
  },
  {
    id: 3,
    category: "网红",
    kicker: "人设崩塌",
    title: "百万粉网红被挖出小号吐槽金主，简介连夜改成哭惨",
    summary:
      "粉丝顺藤摸瓜扒出疑似小号，聊天记录里吐槽品牌方不懂行，被合作方反手截图挂出，双方各执一词。",
    tags: ["人设", "小号", "合作翻车"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20phone%20held%20over%20a%20dimly%20lit%20coffee%20table%20with%20chat%20notification%20glare%2C%20anonymous%20comment%20culture%20theme%2C%20moody%20warm%20window%20light%2C%20no%20person%2C%20shallow%20depth%20of%20field%2C%20film%20look%2C%20documentary%20style&width=1000&height=680&seq=hot-03&orientation=landscape",
    heat: 7.9,
    comments: 1204,
    time: "41分钟前",
  },
  {
    id: 4,
    category: "明星",
    kicker: "旧闻新炒",
    title: "昔日顶流综艺内幕录音曝光，导演组集体沉默",
    summary:
      "一段标注三年期的现场录音流传开来，剪辑与黑幕争议再被点燃，当事人仅以一句会走法律途径回应。",
    tags: ["录音", "综艺", "旧事重提"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20an%20old%20tape%20recorder%20and%20scattered%20scripts%20on%20a%20vintage%20studio%20desk%2C%20warm%20desk%20lamp%20light%2C%20no%20person%2C%20nostalgic%20documentary%20mood%2C%20film%20grain%2C%20deep%20shadows%2C%20editorial%20magazine%20aesthetic&width=1000&height=680&seq=hot-04&orientation=landscape",
    heat: 7.2,
    comments: 986,
    time: "1小时前",
  },
  {
    id: 5,
    category: "网红",
    kicker: "全网声讨",
    title: "探店博主夸大评分被平台处罚，评论区沦陷求真相",
    summary:
      "同一家店被不同博主拍出天壤之别的出品，平台下架其多条推广并限流，粉丝要求晒出原始素材。",
    tags: ["探店", "限流", "评论区"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20stylish%20cafe%20interior%20with%20a%20blurred%20menu%20and%20review%20cards%20scattered%20on%20table%2C%20soft%20warm%20morning%20light%2C%20no%20person%2C%20shallow%20depth%20of%20field%2C%20lifestyle%20magazine%20documentary%20style%2C%20clean%20and%20high%20detail&width=1000&height=680&seq=hot-05&orientation=landscape",
    heat: 6.8,
    comments: 743,
    time: "2小时前",
  },
];

export const rankItems: RankItem[] = [
  {
    id: 1,
    category: "明星",
    name: "沈之衡",
    title: "被曝婚内冷暴力录音，前合作方下场补刀",
    note: "三段录音+合同细节被晒，律师函暂未到",
    trend: "up",
    heat: 9.9,
  },
  {
    id: 2,
    category: "主播",
    name: "大嘴哥",
    title: "带货把压货价说成底价，全网对比图刷屏",
    note: "同款被扒出比旗舰店还贵，直播间改口上架",
    trend: "up",
    heat: 9.6,
  },
  {
    id: 3,
    category: "网红",
    name: "兔厂厂",
    title: "素颜旧照被盗用整容对比，律师函警告",
    note: "AI修复图争议后删博，仍被追着问",
    trend: "up",
    heat: 9.2,
  },
  {
    id: 4,
    category: "明星",
    name: "陆斯年",
    title: "颁奖礼黑脸名场面，主办方紧急改口",
    note: "慢镜头被逐帧解读，场务秒删动态",
    trend: "flat",
    heat: 8.8,
  },
  {
    id: 5,
    category: "主播",
    name: "K宝",
    title: "连麦刷礼被质疑套路，榜一粉丝直播对质",
    note: "榜一晒账单细数打赏去向，平台介入",
    trend: "down",
    heat: 8.4,
  },
  {
    id: 6,
    category: "网红",
    name: "南栀",
    title: "美颜滤镜翻车，生图流出被全网二创",
    note: "滤镜直播现场穿帮，表情包迅速出圈",
    trend: "down",
    heat: 8.0,
  },
  {
    id: 7,
    category: "明星",
    name: "闻琪",
    title: "跨年假唱对口型被扒，站姐集体闭麦",
    note: "声轨分析视频破百万播放，工作室沉默",
    trend: "flat",
    heat: 7.6,
  },
  {
    id: 8,
    category: "网红",
    name: "阿澈",
    title: "抄袭争议再发酵，原作者晒出时间线",
    note: "连续三天发长文，路人口径两极化",
    trend: "up",
    heat: 7.1,
  },
];

export const persons: PersonArch[] = [
  {
    id: 1,
    name: "沈之衡",
    category: "明星",
    glyph: "沈",
    tone: "证据连环",
    tagline: "一瓜更比一瓜实，录音合同样样齐",
    since: "本月 3 日",
    entries: 12,
    peek: "婚内录音、合同底价、对家下场",
  },
  {
    id: 2,
    name: "大嘴哥",
    category: "主播",
    glyph: "嘴",
    tone: "人设反复",
    tagline: "道歉比上链接还快，次次说到做不到",
    since: "本月 5 日",
    entries: 9,
    peek: "低价翻车、改口删评、榜一退粉",
  },
  {
    id: 3,
    name: "兔厂厂",
    category: "网红",
    glyph: "兔",
    tone: "旧账重翻",
    tagline: "黑历史一挖一个准，删了也没用",
    since: "上周 7 日",
    entries: 7,
    peek: "素颜旧照、小号吐槽、滤镜穿帮",
  },
  {
    id: 4,
    name: "陆斯年",
    category: "明星",
    glyph: "陆",
    tone: "名场面制造机",
    tagline: "红毯黑脸、颁奖冷场，表情包供不应求",
    since: "上周 6 日",
    entries: 6,
    peek: "黑脸名场面、记者会抢麦、缺席领奖",
  },
  {
    id: 5,
    name: "南栀",
    category: "网红",
    glyph: "栀",
    tone: "滤镜受害者",
    tagline: "生图一出自闭三天，靠二创续命",
    since: "本月 2 日",
    entries: 5,
    peek: "美颜翻车、生图流出、直播闭麦",
  },
  {
    id: 6,
    name: "K宝",
    category: "主播",
    glyph: "K",
    tone: "榜一修罗场",
    tagline: "刷礼刷到最后反目，对质直播全纪录",
    since: "上月 末",
    entries: 4,
    peek: "榜一退粉、打赏账单、平台介入",
  },
  {
    id: 7,
    name: "闻琪",
    category: "明星",
    glyph: "琪",
    tone: "逐帧鉴定",
    tagline: "假唱对口型被声轨专家盯上",
    since: "本月 8 日",
    entries: 3,
    peek: "假唱名场面、声轨对比、站姐闭麦",
  },
  {
    id: 8,
    name: "阿澈",
    category: "网红",
    glyph: "澈",
    tone: "二创泥潭",
    tagline: "抄袭疑云绕了三个月，长文越写越糊",
    since: "上月 中",
    entries: 3,
    peek: "原创时间线、改口道歉、评论两极",
  },
];

export const timelineCase = {
  title: "沈之衡 · 塌房前 72 小时全纪录",
  intro:
    "从一条深夜热帖到全网定调，我们把这一波事件按时间还原，帮你三分钟看懂来龙去脉。",
  steps: [
    {
      time: "周五 21:40",
      title: "匿名小号发出第一条帖子",
      desc: "有人贴出两张模糊聊天截图，暗示某一线男星婚内冷暴力，迅速被娱乐博主搬运。",
      hot: true,
    },
    {
      time: "周五 23:12",
      title: "热搜空降前十，工作室发声明",
      desc: "热搜带话题冲上前列，工作室仅回应一句“内容失实”，未附任何证据。",
    },
    {
      time: "周六 02:05",
      title: "第二段录音流出，舆论反转",
      desc: "一段标称三年期的录音被放出，语气与“甩锅”金句对得上，评论区风向开始转向。",
    },
    {
      time: "周六 11:30",
      title: "商务合作方集体沉默",
      desc: "多个待宣品牌临时撤稿，粉丝群传出“品牌方内部在评估”截图，股价话题一度刷屏。",
      hot: true,
    },
    {
      time: "周日 09:20",
      title: "当事人深夜发长文 + 录视频",
      desc: "一段没开美颜的回应视频发布，逐条反驳录音真实性，称将走法律途径。",
      image:
        "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20modern%20media%20monitoring%20wall%20with%20multiple%20screens%20showing%20timelines%20and%20news%20tickers%2C%20moody%20blue%20and%20amber%20screen%20glow%20in%20a%20dark%20newsroom%2C%20no%20person%2C%20documentary%20style%2C%20film%20grain%2C%20high%20detail&width=900&height=560&seq=tl-01&orientation=landscape",
    },
    {
      time: "周日 20:00",
      title: "网友整理长图成“塌房时间线”",
      desc: "热心网友把每一条证据做成时间线长图，转发量破十万，成为当周现象级围观现场。",
      image:
        "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20a%20paper%20timeline%20with%20timestamped%20sticky%20notes%20and%20linked%20arrows%20on%20a%20wooden%20desk%2C%20warm%20desk%20lamp%2C%20no%20person%2C%20investigation%20documentary%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=900&height=560&seq=tl-02&orientation=landscape",
    },
  ],
};

export const galleryItems: GalleryItem[] = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20red%20carpet%20scene%20with%20empty%20velvet%20ropes%20and%20paparazzi%20camera%20flashes%20in%20blur%2C%20no%20people%2C%20dramatic%20rim%20lighting%2C%20warm%20and%20dark%20contrast%2C%20film%20look%2C%20editorial%20magazine%20documentary%20style&width=800&height=620&seq=gal-01&orientation=portrait",
    caption: "现场抓拍 · 红毯名场面",
    tag: "现场",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20close%20up%20of%20hands%20holding%20a%20phone%20screen%20showing%20an%20anonymous%20chat%20thread%2C%20dim%20warm%20room%20light%2C%20no%20faces%2C%20documentary%20evidence%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20high%20detail%20editorial%20style&width=800&height=620&seq=gal-02&orientation=portrait",
    caption: "聊天记录 · 一锤定音",
    tag: "实锤",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20cluttered%20backstage%20dressing%20room%20vanity%20mirror%20with%20lights%2C%20half%20empty%20beverage%20cups%20and%20scripts%2C%20no%20person%2C%20warm%20tungsten%20glow%2C%20documentary%20backstage%20mood%2C%20film%20grain%2C%20editorial%20magazine%20look&width=800&height=620&seq=gal-03&orientation=portrait",
    caption: "后台角落 · 未被剪辑的真相",
    tag: "幕后",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20rows%20of%20fans%20holding%20phone%20flashlights%20at%20a%20night%20concert%2C%20seen%20from%20behind%2C%20faces%20blurred%20or%20unseen%2C%20warm%20and%20cool%20stage%20light%20mix%2C%20documentary%20mood%2C%20film%20grain%2C%20high%20detail&width=800&height=620&seq=gal-04&orientation=portrait",
    caption: "粉丝应援 · 支持还是脱粉",
    tag: "应援",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20an%20empty%20modern%20newsroom%20desk%20with%20laptop%20open%20to%20a%20trending%20feed%2C%20coffee%20mug%20and%20notes%2C%20moody%20window%20light%20at%20dusk%2C%20no%20person%2C%20documentary%20journalism%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=800&height=620&seq=gal-05&orientation=portrait",
    caption: "小编工位 · 实时盯热搜",
    tag: "编辑",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20wall%20covered%20in%20printed%20paper%20headlines%20and%20clippings%20with%20red%20annotation%20marks%2C%20no%20people%2C%20warm%20desk%20lamp%20glow%2C%20documentary%20investigation%20mood%2C%20textured%20paper%2C%20film%20grain%2C%20editorial%20magazine%20look&width=800&height=620&seq=gal-06&orientation=portrait",
    caption: "线索墙 · 层层剥茧",
    tag: "深挖",
  },
];

export const comments: CommentItem[] = [
  {
    id: 1,
    user: "一颗脆皮西瓜",
    role: "围观看客",
    text: "这瓜熟透了，录音一出声明就显得特别苍白。建议塌房专业户先把自家声明模板备份好。",
    likes: 892,
    replies: [
      { user: "不吃香菜", text: "哈哈声明模板都有了，就差一个证据包了。", likes: 231 },
      { user: "塌房观察员", text: "建议直接出个《塌房自救手册》合集。", likes: 156 },
    ],
  },
  {
    id: 2,
    user: "深夜emo代购",
    role: "十年老粉",
    text: "追了这么多年，真没想到会以这种方式收场。不是不能接受翻车，是不能接受嘴上说一套背后做一套。",
    likes: 1204,
    replies: [{ user: "路过的猹", text: "姐妹清醒，钱省下来给自己买好吃的不香吗。", likes: 88 }],
  },
  {
    id: 3,
    user: "吃瓜不吐籽",
    role: "鉴瓜大师",
    text: "先别急着定论，等一手原声轨对比和商务解约函，锤还没到最实的时候。让子弹再飞一会儿。",
    likes: 467,
    replies: [
      { user: "理性吃瓜", text: "同意，现在证据链还差关键一环，蹲后续。", likes: 45 },
      { user: "一线吃瓜群众", text: "好家伙，你比工作室还严谨。", likes: 12 },
    ],
  },
  {
    id: 4,
    user: "猹某",
    role: "专业搬运",
    text: "给新来的朋友指路：时间线在隔壁专栏，聊天记录长图在实锤图鉴，评论区蹲真相的记得关注更新。",
    likes: 320,
    replies: [{ user: "摆烂的猹", text: "收藏了，就等你这条置顶哈哈。", likes: 60 }],
  },
];

export const poll = {
  question: "这一轮塌房潮，你押谁最快复出翻车？",
  hint: "纯围观投票，不构成任何定论",
  options: [
    { label: "沈之衡（证据最实）", votes: 5216 },
    { label: "大嘴哥（道歉最勤）", votes: 3410 },
    { label: "兔厂厂（旧账最多）", votes: 2308 },
    { label: "说不准，都再看看", votes: 1102 },
  ],
};

export const reportMeta = [
  { label: "今日新瓜", value: "47" },
  { label: "正在围观", value: "12.6 万" },
  { label: "累计收录人物", value: "3200+" },
  { label: "平均每小时更新", value: "6 条" },
];